/** Thin wrapper so call sites import from one place. */
export const uuid = (): string => crypto.randomUUID()
